import React from "react";
import { Link } from "react-router-dom";
import CatalogImage from "../common/CatalogImage";
import StatusBadge from "../common/StatusBadge";
import { formatCurrency } from "../../lib/catalog";
import { hotelBadge, hotelPrice, hotelStarsLabel } from "./hotelCatalog";

export default function HotelCard({ hotel }) {
  const price = hotelPrice(hotel);

  return (
    <article className="card h-100 border-0 shadow-sm catalog-card package-card">
      <CatalogImage
        folder="umrah_hotel_list"
        fileName={hotel.image}
        alt={hotel.name}
        height="auto"
        className="package-card__image"
      />
      <div className="card-body d-flex flex-column">
        <div className="package-card__top">
          <div className="text-uppercase text-secondary small fw-semibold package-card__code">
            {hotel.code || "No code"}
          </div>
          <StatusBadge className="flex-shrink-0" value={hotelBadge(hotel)} />
        </div>

        <h5 className="card-title package-card__name" title={hotel.name}>
          {hotel.name}
        </h5>

        <div className="package-card__meta">
          <div className="package-card__row">
            <span className="package-card__label">Ratings</span>
            <span className="package-card__value">{hotelStarsLabel(hotel)}</span>
          </div>
          <div className="package-card__row">
            <span className="package-card__label">Distance</span>
            <span className="package-card__value">{hotel.formattedDistance || hotel.distance || "Not set"}</span>
          </div>
          {/* <div className="package-card__row">
            <span className="package-card__label">Type</span>
            <span className="package-card__value">{hotel.propertyType || "Not set"}</span>
          </div> */}
        </div>

        <div className="package-card__footer mt-auto">
          <div className="package-card__prices">
            <div className="package-card__label">Net Price</div>
            <div className="package-card__net">{price == null ? "Not set" : formatCurrency(price)}</div>
          </div>
          <Link to={`/hotels/${hotel.slug || hotel.id}`} className="btn btn-primary btn-sm package-card__book">
            Book
          </Link>
        </div>
      </div>
    </article>
  );
}
